import $ from 'jquery'

$(document).on('change', '.select-template-field-kind', function(event) {
  event.preventDefault()
  if ($(this).val() === 'selection') {
    $(this).closest('fieldset').find('.field_options').show()
  } else {
    $(this).closest('fieldset').find('.field_options').hide()
  }
})

// Change order/position of header info and measuring points
// ---------------------------------------------------------

// DRY version of hideAndShowPositionLinks function
const hideAndShowPositionLinks = (fields) => {
  const visibleFields = $(fields).filter(':visible')
  const countOfFields = visibleFields.length

  $(visibleFields).each(function(index) {
    $(this).find('.position').val(index + 1)

    // Hide position links if there is only one field
    if (countOfFields === 1) {
      $(this).find('.position_up').css('visibility', 'hidden')
      $(this).find('.position_down').css('visibility', 'hidden')
      $(this).find('.positon_handle').css('visibility', 'hidden')
      return
    }

    if (index === 0) {
      // First element
      $(this).find('.position_up').css('visibility', 'hidden')
      $(this).find('.position_down').css('visibility', 'visible')
      $(this).find('.positon_handle').css('visibility', 'visible')
    } else if (index === countOfFields - 1) {
      // Last element (unless there are only two elements)
      $(this).find('.position_down').css('visibility', 'hidden')
      $(this).find('.position_up').css('visibility', 'visible')
    } else {
      // All other elements
      $(this).find('.position_down').css('visibility', 'visible')
      $(this).find('.position_up').css('visibility', 'visible')
    }
  })
}

// DRY version of moveItem function
const moveItem = (fields, direction) => {
  $(document).on('click', `${fields} .position_${direction}`, function(event) {
    event.preventDefault()

    const fieldItem = $(this).closest(fields)
    const fieldItemSibling = fieldItem[direction === 'up' ? 'prev' : 'next'](fields)
    fieldItem[direction === 'up' ? 'insertBefore' : 'insertAfter'](fieldItemSibling)

    hideAndShowPositionLinks(fields)
  })
}

$(document).on('cocoon:after-insert', () => {
  hideAndShowPositionLinks('.header_info_fields')
  hideAndShowPositionLinks('.maintenance_template_fields')
})

$(document).on('cocoon:after-remove', () => {
  hideAndShowPositionLinks('.header_info_fields')
  hideAndShowPositionLinks('.maintenance_template_fields')
})

$(document).on('turbo:load', () => {
  hideAndShowPositionLinks('.header_info_fields')
  hideAndShowPositionLinks('.maintenance_template_fields')
})

// Use general functions for .header_info_fields and .maintenance_template_fields
for (const field of ['.header_info_fields', '.maintenance_template_fields']) {
  hideAndShowPositionLinks(field)
  moveItem(field, 'up')
  moveItem(field, 'down')
}

$(document).on('turbo:load', () => {
  $('#maintenance_template_form .sortable').sortable({
    cursor: 'move',
    handle: '.positon_handle',
    update: () => {
      hideAndShowPositionLinks('.header_info_fields')
      hideAndShowPositionLinks('.maintenance_template_fields')
    }
  })
})
